/**
 * @description opciones de configuración para el componente
 */
export enum iconType {
    icon = 'icon',
    image = 'image'
}
export interface Options {
    iconType?: iconType
}